import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuStateService {
  private adminMenuOpen = new BehaviorSubject<boolean>(false);
  private currentSubMenu = new BehaviorSubject<string>('');

  // Observable para o estado do menu admin
  isAdminMenuOpen$ = this.adminMenuOpen.asObservable();
  currentSubMenu$ = this.currentSubMenu.asObservable();

  openAdminMenu(): void {
    this.adminMenuOpen.next(true);
    this.currentSubMenu.next('');
  }

  closeAdminMenu(): void {
    this.adminMenuOpen.next(false);
    this.currentSubMenu.next('');
  }

  setSubMenu(subMenu: string): void {
    this.currentSubMenu.next(subMenu);
  }

  goBackToMainMenu(): void {
    this.currentSubMenu.next('');
  }

  openCreditoMenu(): void {
    this.currentSubMenu.next('CREDITO');
  }

  // Método para verificar se deve fechar o menu admin
  shouldCloseAdminMenu(): boolean {
    return this.currentSubMenu.value === '';
  }
}
